import styled from "styled-components";
import { useRef, useEffect, useState } from "react";
import { ProxiesSketchInstance } from "./main";
import p5 from "p5";

import VisDemoExplanation from "./VisDemoExplanation";
import VisDemoTracker from "./VisDemoTracker";

const VisContainer = styled.div`
    width: 100%;
    height: 100vh;
    position: relative;


`;



const HiddenSVGElement = styled.svg`
    display: none;
`;

const MouseTrailElement = () => {

    return <HiddenSVGElement id="mouse_trail" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1228.4 702.6"><path id="mouse_trail_path" d="M9.8,140.7C48.3,39.1,198.5,14.3,221.6,10.5,288.4-.6,379.5-15.6,441.4,47.3c55,55.9,61.6,147.8,30.3,213.2-49.3,103-180.5,115.6-200,117.1-74.9,5.9-94.8-26.6-150-7.9-57.6,19.5-113.1,81.1-113.2,151.3,0,84.6,80.3,137.1,94.7,146.1,111.4,69.4,280.1,27.3,388.2-51.3,69.1-50.3,130.3-146.3,252.6-338.2,43.3-67.9,66.8-109.5,122.4-146.1,17.2-11.3,141.9-93.4,252.6-34.2,73.1,39.1,95.4,115.8,100,131.6,33,113.4-35.8,207.5-46.1,221.1-76.5,101.1-199.9,107.3-239.5,109.2-33,1.6-145.4,7.2-227.6-67.1-67.7-61.2-106.9-169.4-111.8-259.2-2.3-41.6,2.2-88.9-30.3-131.6-6.7-8.8-30.7-39.5-71.1-47.4-63.6-12.4-116.9,41.6-123.7,48.7-37.6,39.2-24.3,65.5-72.4,125-13.4,16.6-28.1,34.8-52.6,51.3-14.7,9.9-96.3,61.9-171.1,23.7-5.4-2.8-57.2-30.3-69.7-88.2-7.6-35.1,2.9-64.1,6.6-73.7Z" /></HiddenSVGElement>;

}

const ProxiesVis = ({ which }) => {

    // let [sampleData, setSampleData] = useState(null);
    let [globalWhichStudy, setGlobalWhichStudy] = useState("Pressing");


    const p5ContainerRef = useRef();

    useEffect(() => {
        // On component creation, instantiate a p5 object with the sketch and container reference 
        const p5Instance = new p5(ProxiesSketchInstance(setGlobalWhichStudy), p5ContainerRef.current);

        setGlobalWhichStudy("Pressing");

        // On component destruction, delete the p5 instance
        return () => {
            p5Instance.remove();
        }
    }, []);

    /*
    useEffect(() => {

        csv(SampleData, (d) => {

            return {
                ...d,
                t: Math.round(+d.t / 2),
                s1: +d.s1,
                s2: +d.s2,
                s3: +d.s3,
                s4: +d.s4
            };

        }).then((d) => {
            setSampleData(d);
        });

        return () => undefined;

    }, []);
    */


    return (<>
        <MouseTrailElement />
        <VisContainer ref={p5ContainerRef} >
            <VisDemoExplanation />
            <VisDemoTracker whichStudy={globalWhichStudy} />
        </VisContainer>

    </>
    );
}

export default ProxiesVis;